export default function Clock(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.2035 33.5359C13.1992 36.5988 17.3778 38.5 22 38.5C31.1118 38.5 38.5 31.1118 38.5 22C38.5 12.8882 31.1118 5.5 22 5.5C17.5549 5.5 13.5199 7.25831 10.5529 10.1173"
                stroke="#010101"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path d="M22 12.8333V23.8333L29.3333 20.1666" stroke="#010101" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.16665 14.6667L4.58331 22.0001H11L6.41665 29.3334" stroke="#010101" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
